import {_, React, observer, observable, computed, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource, Fragment} from '@api'
import {CustomDetailsTemplateStore, useCustomDetailsTemplateStore, useVipLocalStore, VipLocalStore} from '@modules'
import {IOverviewTableCatalogItemDetailTemplateColumn, IOverviewTableCatalogItemDetailTemplateField, IOverviewTableCatalogItemDetailTemplateRow, StoresInstance, ui} from '@stores'
import {IDisposer} from 'mobx-utils'
import * as css from './DetailsTemplate_OverviewGrid.css'

/// region Store

export class DetailsTemplate_OverviewGridStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: { templateStore: CustomDetailsTemplateStore } & Omit<MyProps, 'className'>) {
    super(stores)
  }

  registerEffects = () => {
    const toDispose: Array<IDisposer> = []

    return () => toDispose.forEach(d => d())
  }

  get templateStore() {return this.props.templateStore}

  get template() {return this.templateStore.template}

  get details() { return this.templateStore.details}

  get data() { return this.details.data}
}

export const DetailsTemplate_OverviewGridStoreContext = React.createContext<DetailsTemplate_OverviewGridStore>(null)
export const useDetailsTemplate_OverviewGridStore = () => React.useContext(DetailsTemplate_OverviewGridStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
}

export const DetailsTemplate_OverviewGrid = observer<MyProps>(function DetailsTemplate_OverviewGrid({className, ...props}) {
  const templateStore = useCustomDetailsTemplateStore(),
    obsProps = useAsObservableSource({templateStore}),
    store = useVipLocalStore((stores) => new DetailsTemplate_OverviewGridStore(templateStore.details.stores, obsProps)),
    {template: {layout: {upperLeft, upperRight, rows}}} = store

  useEffect(() => store.registerEffects(), [])

  return (
    <DetailsTemplate_OverviewGridStoreContext.Provider value={store}>
      <div className={classNames(css.root, className)}>
        <div className={css.grid}>
          <div className={css.scrollContainer}>
            <div className={css.gridHeader}>
              <GridSectionFields fields={upperLeft} className={css.left}/>
              <GridSectionFields fields={upperRight} className={css.right}/>
            </div>

            {(rows ?? []).map((r, i) => <GridRow key={i} row={r}/>)}

            {/*<GridFooter />*/}
          </div>
        </div>
      </div>
    </DetailsTemplate_OverviewGridStoreContext.Provider>)
})

const GridSectionFields = observer<{ className?: string, fields: Array<IOverviewTableCatalogItemDetailTemplateField> }>(function GridSectionFields({className, fields}) {
  const {} = useDetailsTemplate_OverviewGridStore()

  if (_.isEmpty(fields)) return null

  return (<div className={classNames(css.sectionFields, className)}>
    {fields.map((f, i) => <GridSectionField field={f} key={i}/>)}
  </div>)
})

const GridSectionField = observer<{ field: IOverviewTableCatalogItemDetailTemplateField }>(function GridSectionField({field: {field, agg}}) {
  const {es: {readField}, catalog: {labelFor, labelForFieldName_currentCatalog}, templateStore: {details: {data}}} = useDetailsTemplate_OverviewGridStore(),
    value = readField(data, field)?.val

  return (<React.Fragment>
    <div className={css.field} data-field={field} data-agg={agg}>
      <label>{labelForFieldName_currentCatalog(field)}:</label>
      <span className={css.value}>{labelFor(value)}</span>
    </div>
  </React.Fragment>)
})

const GridRow = observer<{ row: IOverviewTableCatalogItemDetailTemplateRow }>(function GridRow({row: {columns, heroImage, type}}) {
  const {} = useDetailsTemplate_OverviewGridStore()

  return (<div className={css.gridRow}>
    {type === 'images' && <div className={css.images}>Images go here</div>}

    {(columns ?? []).map((c, j) => c.field ? <GridRowColumn_ForField col={c} key={j}/> : <div>agg goes here</div>)}
  </div>)
})

const GridRowColumn_ForField = observer<{ col: IOverviewTableCatalogItemDetailTemplateColumn }>(function GridRowColumn({col}) {
  const templateStore = useDetailsTemplate_OverviewGridStore(),
    {es, catalog: {_fieldByName, labelForField}, data} = templateStore,
    field = _fieldByName[col.field],
    rowLabel = labelForField(field),
    value = es.readField(data, col.field)

  return (
    <Fragment>
      {field && <div className={css.rowLabel}>{rowLabel}</div>}
      <div className={css.gridColumn} data-field={field}>
        <div className={css.gridColumnValue} dangerouslySetInnerHTML={{ __html: value?.val}} />
      </div>
    </Fragment>)
})
/// endregion




// WEBPACK FOOTER //
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/Modal/DetailsTemplates/DetailsTemplate_OverviewGrid.tsx